import React, { useState } from "react";
import { lqip } from "../lib/api";

// Blur-up image: shows a tiny, blurred low-res preview (or a muted tone) while the full
// image streams in, then fades the sharp image over it. Keeps the crop/layout identical.
export const BlurImage = ({ src, srcSet, sizes, alt, className = "", width, height, eager = false, tiny, ...rest }) => {
  const [loaded, setLoaded] = useState(false);
  const preview = tiny || lqip(src);
  return (
    <div className="relative overflow-hidden bg-[#F0EFEA]">
      {preview && !loaded && (
        <img src={preview} aria-hidden="true" alt=""
          className="absolute inset-0 w-full h-full object-cover blur-xl scale-110" />
      )}
      <img
        src={src} srcSet={srcSet} sizes={sizes} alt={alt} width={width} height={height}
        loading={eager ? "eager" : "lazy"} decoding="async"
        onLoad={() => setLoaded(true)}
        className={`${className} relative transition-opacity duration-700 ease-out ${loaded ? "opacity-100" : "opacity-0"}`}
        {...rest}
      />
    </div>
  );
};
